export function loadStonly() {
  //load stonly widget
  if (!document.querySelector("[stonlywidget]")) {
    const stonlyWidgetScript = `
          window.STONLY_WID = "56cc13f8-2a9f-11ec-83f1-062882f67cfe";
      !(function (s, t, o, n, l, y, w, g) {
        s.StonlyWidget ||
          (((w = s.StonlyWidget =
            function () {
              w._api ? w._api.apply(w, arguments) : w.queue.push(arguments);
            }).scriptPath = n),
          (w.queue = []),
          ((y = t.createElement(o)).async = !0),
          (g = new XMLHttpRequest()).open("GET", n + "version?v=" + Date.now(), !0),
          (g.onreadystatechange = function () {
            4 === g.readyState &&
              ((y.src =
                n +
                "stonly-widget.js?v=" +
                (200 === g.status ? g.responseText : Date.now())),
              (l = t.getElementsByTagName(o)[0]).parentNode.insertBefore(y, l));
          }),
          g.send());
      })(window, document, "script", "https://stonly.com/js/widget/v2/");`;

    const s = document.createElement("script");
    s.setAttribute("stonlywidget", "1");
    s.innerHTML = stonlyWidgetScript;
    document.body.appendChild(s);
  }
}

export function loadStatusPage() {
  // inject status page script
  const statusPageScript = document.createElement("script");
  const statusPageCode = `
    (function(){

    var frame = document.createElement('iframe');
    frame.src = 'https://jvy3rsjw7r8d.statuspage.io/embed/frame';
    frame.style.position = 'fixed';
    frame.style.border = 'none';
    frame.style.boxShadow = '0 20px 32px -8px rgba(9,20,66,0.25)';
    frame.style.zIndex = '9999';
    frame.style.transition = 'left 1s ease, bottom 1s ease, right 1s ease';

    frame.title = 'Smeetz Status';
    frame.ariaHidden = true;

    var mobile;
    if (mobile = screen.width < 450) {
      frame.src += '?mobile=true';
      frame.style.height = '20vh';
      frame.style.width = '100vw';
      frame.style.left = '-9999px';
      frame.style.bottom = '-9999px';
      frame.style.transition = 'bottom 1s ease';
    } else {
      frame.style.height = '115px';
      frame.style.width = '320px';
      frame.style.left = 'auto';
      frame.style.right = '-9999px';
      frame.style.bottom = 'calc(100% - 175px)';
    }

    document.body.appendChild(frame);

    var actions = {
      showFrame: function() {
        frame.tabIndex = '0';
        if (mobile) {
          frame.style.left = '0';
          frame.style.bottom = '0';
        }
        else {
          frame.style.left = 'auto';
          frame.style.right = '60px'
        }
      },
      dismissFrame: function(){
        frame.style.left = '-9999px';
        frame.tabIndex = '-1';
      }
    }

    window.addEventListener('message', function(event){
      if (event.data.action && actions.hasOwnProperty(event.data.action)) {
        actions[event.data.action](event.data);
      }
    }, false);

    window.statusEmbedTest = actions.showFrame;
})();
    `;
  statusPageScript.innerHTML = statusPageCode;
  document.body.appendChild(statusPageScript);
}
